<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.purchases'), $t('text.create') + '：我的产品']"
      ></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.supplierProductNo"
            :placeholder="$t('product.supplierProductNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>

    <div class="wrapper table-area">
      <div v-if="records && records.length != 0">
        <el-row :gutter="5">
          <el-col
            v-for="(row, rowIndex) in records"
            :key="rowIndex"
            :span="4"
            class="mgt10"
          >
            <el-card :body-style="{ padding: '0px' }">
              <div style="height: 280px">
                <div class="image-div">
                  <thumbnail :images="row.images" width="100%" height="auto" />
                </div>
                <div class="pd5">
                  <el-row class="mgb5">
                    <el-col :span="24" class="overflow">
                      <span v-if="row.verifyAt != null" class="green font10">
                        ({{ $t("product.verify") }})
                      </span>
                      {{ row.productNo }}
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" class="overflow">
                      <div style="min-height: 21px">
                        {{ row.categoryName }}
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="18" class="overflow red">
                      <el-popover
                        v-if="
                          row.productSizePrices &&
                          row.productSizePrices.filter(
                            (p) => p.salesPrice != null
                          ).length != 0
                        "
                        placement="right"
                        width="200"
                        trigger="click"
                      >
                        <div
                          v-for="sizePrice of row.productSizePrices.filter(
                            (p) => p.salesPrice != null
                          )"
                          :key="sizePrice.id"
                          class="font14 mgb5 lineH24"
                        >
                          {{ sizePrice.size }}:
                          {{ sizePrice.salesPrice | currency }}
                        </div>

                        <span slot="reference" class="popover-reference font10">
                          {{ row.salesPrice | currency }}
                        </span>
                      </el-popover>
                      <span v-else class="font10">
                        {{ row.salesPrice | currency }}
                      </span>
                    </el-col>
                    <el-col :span="6" class="overflow tr right">
                      <div
                        type="text"
                        class="float-right blue font14"
                        @click="placePurchase(row)"
                      >
                        {{ $t("action.place") }}
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div v-else class="noData">{{ $t("text.noData") }}</div>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <drawer
      :title="$t('action.place')"
      :visible.sync="placeMyProductDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <place-my-product
        :uuid="currentRowUuid"
        @close="placeMyProductDF = false"
      />
    </drawer>
  </div>
</template>

<script>
import axios from "axios";
import Util from "@/utils/index.js";
import { page, table } from "@/utils/mixins.js";
import PagerConfig from "@/config/pager.js";
import Product from "@/api/product.js";
import Category from "@/api/category.js";
import Label from "@/api/label.js";
import Brand from "@/api/brand";
import PlaceMyProduct from "./placeMyProduct.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    // table.checker,
    table.sorter,
    table.basic,
  ],
  components: { PlaceMyProduct },
  data() {
    return {
      Util: Util,
      labels: [],
      narrows: [
        [
          {
            label: this.$t("product.verifyInfo"),
            items: [
              {
                label: this.$t("verifyInfos.yes"),
                key: "yes",
                condition: { verify: "yes" },
              },
              {
                label: this.$t("verifyInfos.no"),
                key: "no",
                condition: { verify: "no" },
              },
            ],
          },
        ],
      ],
      searchForm: {
        productNo: null,
        supplierProductNo: null,
      },
      sorter: {
        sortBy: "products_refreshAt",
        sortIndicator: "desc",
      },
      pagerConfig: PagerConfig.product,
      pager: {
        currentPage: 1,
        pageSize: PagerConfig.product.defaultPageSize,
        total: 0,
      },
      //
      placeMyProductDF: false,
      currentRowId: null,
      currentRowUuid: null,
    };
  },
  mounted() {},
  created() {
    const self = this;
    axios
      .all([
        Category.findByTenantId(),
        Label.findByTenantId(),
        Brand.findByTenantId(),
      ])
      .then(
        axios.spread(function (categories, labels, brands) {
          if (categories.status === 200) {
            if (categories.data.length !== 0) {
              self.narrows.push([
                {
                  label: self.$t("product.category"),
                  items: categories.data.map((category) => {
                    return {
                      label: category.name,
                      key: category.id,
                      condition: { categoryId: category.id },
                    };
                  }),
                },
              ]);
            }
          } else {
            self.sysError();
          }
          if (labels.status === 200) {
            self.labels = labels.data;
          } else {
            self.sysError();
          }
          if (brands.status === 200) {
            self.narrows.push([
              {
                label: self.$t("product.label"),
                items: labels.data.map((label) => {
                  return {
                    label: label.name,
                    key: label.name,
                    condition: { label: label.name },
                  };
                }),
              },
              {
                label: self.$t("product.brand"),
                items: brands.data.map((brand) => {
                  return {
                    label: brand.name,
                    key: brand.name,
                    condition: { brand: brand.name },
                  };
                }),
              },
            ]);
          } else {
            self.sysError();
          }
        })
      );
  },

  methods: {
    placePurchase(row) {
      this.currentRowUuid = row.uuid;
      this.placeMyProductDF = true;
    },
    dataProvider(params) {
      return Product.search(params);
    },
  },
};
</script>
<style scoped>
.image-div {
  height: 200px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.product-checkbox-div {
  position: absolute;
  width: 16%;
}
.product-label-div {
  position: absolute;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}
.product-label {
  background: #d83732;
  border: 1px solid #d83732;
  margin: 1px 0;
  text-align: left;
  padding: 2px 6px 2px 2px;
  font-size: 12px;
  display: inline-block !important;
  display: inline;
  border-bottom-right-radius: 40px;
  border-top-right-radius: 40px;
  color: #fff;
  opacity: 0.8;
  /* width: auto; */
  /* max-width: 60px; */
  /* overflow: hidden; */
}
</style>